if (!customElements.get('rahlle-shop')) {
  customElements.define('rahlle-shop', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.links = [...this.querySelectorAll('[data-filter]')];
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.links.forEach(link => {
        const exists = link.dataset.filter === 'all' || this.groups.some(group => group.dataset.group === link.dataset.filter);
        link.hidden = !exists;
      });
      const update = () => {
        const requested = location.hash.slice(1);
        const selected = this.groups.some(group => group.dataset.group === requested) ? requested : 'all';
        let count = 0;
        this.groups.forEach(group => {
          group.hidden = selected !== 'all' && group.dataset.group !== selected;
          if (!group.hidden) count += Number(group.dataset.count);
        });
        this.links.forEach(link => {
          if (link.dataset.filter === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        this.querySelector('[data-filter-status]').textContent = `${count} products shown`;
      };
      this.links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        history.pushState(null, '', link.hash);
        update();
      }, { signal }));
      window.addEventListener('hashchange', update, { signal });
      window.addEventListener('popstate', update, { signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
